<po-page-default p-title="Detalhes da Análise">

    <div class="po-row">
        <po-breadcrumb [p-items]="breadcrumbItems"></po-breadcrumb>
    </div>
    <br>
    <div class="po-row">
      <po-info p-label="ID" class="po-md-3" [p-value]="analysis.id"></po-info>
      <po-info p-label="Data" class="po-md-2" [p-value]="analysis.created_at" ></po-info>
      <div class="po-md-7" style="display: flex; justify-content: flex-end; align-items: center;">
        <po-button 
          p-label="Download Análise" 
          p-kind="secondary" 
          p-icon="po-icon-download" 
          (p-click)="downloadAnalysis()">
        </po-button>
      </div>
    </div>
    <br>
    <div class="po-row">
        <p class="po-info-label" style="padding: 0 8px">Query Completa</p>
        <po-textarea class="po-md-12" name="fullquery" [(ngModel)]="analysis.query" p-readonly="true"></po-textarea>
    </div>

    <br>

    <div class="po-row">
        <p class="po-info-label" style="padding: 0 8px">Resultados</p>
        <po-table 
        class="po-md-12"
        p-sort="true" 
        [p-columns]="resultTableColumns" 
        [p-items]="analysis.results"
        p-hide-columns-manager="true"
        >
            <ng-template
                p-table-row-template
                let-rowItem
                let-i="rowIndex"
                [p-table-row-template-arrow-direction]="'left'"
            >
                <po-code-editor 
                    p-label="Result" 
                    class="po-md-12" 
                    [p-readonly]="true" 
                    [(ngModel)]="rowItem.result"
                    p-language="json" 
                    p-readonly="true" 
                    p-show-diff="false" 
                    p-theme="vs-dark">
                </po-code-editor>
            </ng-template>
        </po-table>
    </div>

    <br>

    <div class="po-row" *ngIf="!analysis.suggestions || analysis.suggestions.length === 0">
        <po-button class="po-button po-md-12" p-kind="primary" (p-click)="analyzeWithAI()" p-label="Analisar com IA"></po-button>
    </div>

    <div class="po-row" *ngIf="analysis.suggestions && analysis.suggestions.length > 0">
        <p class="po-info-label" style="padding: 0 8px">Sugestões de IA</p>
        <po-code-editor 
            p-label="Result" 
            class="po-md-12" 
            [p-readonly]="true" 
            [(ngModel)]="analysis.suggestions"
            p-language="markdown"
            p-readonly="true"
            p-show-diff="false"
            p-height="300" 
            p-theme="vs-dark">
        </po-code-editor>
    </div>

    <div class="sample-container" *ngIf="loading">
        <po-loading-overlay></po-loading-overlay>
    </div>
</po-page-default>

